import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  TicketIcon,
  Bars3Icon,
  XMarkIcon,
  ArrowRightOnRectangleIcon,
} from '@heroicons/react/24/outline';
import SearchDropdown from '../search/SearchDropdown';
import { useAuth } from '../../lib/AuthContext';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { logout } = useAuth();

  return (
    <nav className="sticky top-0 z-50 bg-slate-800/80 backdrop-blur-xl border-b border-slate-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo / Brand */}
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <div className="w-8 h-8 rounded-lg bg-emerald-600 flex items-center justify-center">
              <TicketIcon className="w-5 h-5 text-white" />
            </div>
            <span className="text-lg font-semibold text-slate-100 hidden sm:block">
              Ticketed <span className="text-emerald-400">Compare</span>
            </span>
          </Link>

          {/* Search bar — desktop */}
          <SearchDropdown className="hidden md:block flex-1 max-w-md mx-8" />

          {/* Desktop nav links */}
          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className="px-3 py-2 rounded-lg text-sm font-medium text-slate-300
                         hover:bg-slate-700/60 hover:text-slate-100 transition-colors"
            >
              Fixtures
            </Link>
            <Link
              to="/leagues"
              className="px-3 py-2 rounded-lg text-sm font-medium text-slate-300
                         hover:bg-slate-700/60 hover:text-slate-100 transition-colors"
            >
              Leagues
            </Link>
            <Link
              to="/insights"
              className="px-3 py-2 rounded-lg text-sm font-medium text-slate-300
                         hover:bg-slate-700/60 hover:text-slate-100 transition-colors"
            >
              Insights
            </Link>
            <button
              onClick={logout}
              className="ml-2 p-2 rounded-lg text-slate-400 hover:text-slate-200
                         hover:bg-slate-700/60 transition-colors"
              title="Sign out"
            >
              <ArrowRightOnRectangleIcon className="w-5 h-5" />
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg text-slate-400 hover:text-slate-200
                       hover:bg-slate-700/60 transition-colors"
          >
            {mobileMenuOpen ? (
              <XMarkIcon className="w-6 h-6" />
            ) : (
              <Bars3Icon className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-slate-700/50 bg-slate-800">
          <div className="px-4 py-3 space-y-3">
            {/* Mobile search */}
            <SearchDropdown onNavigate={() => setMobileMenuOpen(false)} />

            {/* Mobile nav links */}
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-3 py-2 rounded-lg text-sm font-medium text-slate-300
                         hover:bg-slate-700/60 hover:text-slate-100 transition-colors"
            >
              Fixtures
            </Link>
            <Link
              to="/leagues"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-3 py-2 rounded-lg text-sm font-medium text-slate-300
                         hover:bg-slate-700/60 hover:text-slate-100 transition-colors"
            >
              Leagues
            </Link>
            <Link
              to="/insights"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-3 py-2 rounded-lg text-sm font-medium text-slate-300
                         hover:bg-slate-700/60 hover:text-slate-100 transition-colors"
            >
              Insights
            </Link>
            <button
              onClick={() => { setMobileMenuOpen(false); logout(); }}
              className="w-full text-left px-3 py-2 rounded-lg text-sm font-medium text-slate-300
                         hover:bg-slate-700/60 hover:text-slate-100 transition-colors"
            >
              Sign out
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
